import Script from 'next/script'

export const renderSnippet = (nonce: string, gtmId?: string) => {
  return (
    <>
      <Script
        id="gtm-first"
        nonce={nonce}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;var n=d.querySelector('[nonce]');
        n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
      `,
        }}
      />
    </>
  )
}

export const renderSnippetNoScript = (gtmId?: string) => {
  return (
    <noscript>
      <iframe
        height="0"
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        style={{ display: 'none', visibility: 'hidden' }}
        width="0"
      ></iframe>
    </noscript>
  )
}
